import React from 'react';
import Carousel from './Carousel';
import ServiceSection from './ServiceSection ';
import AboutSection from './AboutSection';
import Categories from './Categories';
import Projects from './Projects';
import Facts from './Facts';
import Testimonial from './Testimonial';
const HomeComponent = () => {
    return (
        <div>
            <Carousel />
            <ServiceSection />
            <AboutSection />
            <Facts />
            <Projects /> 
            <Testimonial /> 
        </div>

    );
};

export default HomeComponent;
